import { SVGProps } from 'react'

export const ProfileAvatarsListHeaderBorderIcon = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      width="271rem"
      height="51rem"
      viewBox="0 0 271 51"
      fill="none"
      {...props}
    >
      <g filter="url(#filter0_d_2382_6783)">
        <path
          d="M20 58L39.7809 16.1612C42.4255 10.5675 48.0583 7 54.2457 7H214.754C220.942 7 226.574 10.5675 229.219 16.1612L249 58"
          stroke="url(#paint0_linear_2382_6783)"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter1_d_2382_6783)">
        <path
          d="M10 58L35.4683 14.8652C38.3463 9.99088 43.5855 7 49.246 7H219.754C225.414 7 230.654 9.99088 233.532 14.8652L259 58"
          stroke="url(#paint1_linear_2382_6783)"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter2_d_2382_6783)">
        <path
          d="M2 58L30.3809 14.2872C33.3316 9.74248 38.382 7 43.8006 7H225.478C230.743 7 235.671 9.59021 238.657 13.9268L269 58"
          stroke="url(#paint2_linear_2382_6783)"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter3_d_2382_6783)">
        <path
          d="M-8 58L25.3129 13.4222C28.3334 9.38025 33.0837 7 38.1295 7H231.116C236.023 7 240.659 9.25168 243.692 13.1086L279 58"
          stroke="url(#paint3_linear_2382_6783)"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2382_6783"
          x1="133.973"
          y1="64.5"
          x2="133.973"
          y2="-0.499999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2382_6783"
          x1="133.927"
          y1="64.5"
          x2="133.927"
          y2="-0.499999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2382_6783"
          x1="134.886"
          y1="64.5"
          x2="134.886"
          y2="-0.499999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2382_6783"
          x1="134.885"
          y1="64.5"
          x2="134.885"
          y2="-0.499999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
      </defs>
    </svg>
  )
}
